import { jsx } from "react/jsx-runtime";
const SvgRowArrow = (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M11 7L14 12L11 17", stroke: "currentColor", strokeOpacity: 0.9, strokeWidth: 2 }) });
export default SvgRowArrow;
